/**
 * API for running orders.
 * @module api/runningOrder
 */

import Settings from '../settings';

const serverPath = Settings.serverPath;

 /**
  * Retrieves a specified story from the server.
  * @func getRunningOrder
  * @param {string} runningOrderId Id of the running order to retrieve.
  * @return {Promise<Object|Error>}
  */
export const getRunningOrder = (runningOrderId) => fetch(`${serverPath}Services/RunningOrderRestService.svc/runningorders`, {
  method: 'post',
  mode: 'cors',
  body: runningOrderId,
  cache: 'no-cache',
  credentials: 'include',
  dataType: 'json'
}).then(response => {
  if (response.ok) {
    return response.json();
  }
  throw (new Error('Error parsing response.'));
}).then(data => {
  if (data.statusCode === 500) {
    console.log(data);
    throw (new Error('Unexpected error getting assets. Bad JSON received.'));
  }
  return Promise.resolve(JSON.parse(data));
}).catch(error => { throw (new Error(`getRunningOrder failed: ${error}`)); });

 /**
  * Retrieves a list of running orders from the server.
  * @func getRunningOrdersList
  * @return {Promise<Object[]|Error>}
  */
export const getRunningOrdersList = () => fetch(`${serverPath}Services/RunningOrderRestService.svc/runningorders`, {
  method: 'get',
  mode: 'cors',
  cache: 'no-cache',
  credentials: 'include',
  dataType: 'json'
}).then(response => {
  if (response.ok) {
    return response.json();
  }
  throw (new Error('Error parsing response.'));
}).then(data => Promise.resolve(JSON.parse(data)))
 .catch(error => { throw (new Error(`getRunningOrdersList failed: ${error}`)); });



// WEBPACK FOOTER //
// ./app/api/runningOrder.js